// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"40038a32","236":"2b58a27e","389":"5b7094f6","515":"5e7495b5","526":"8e1a7d05","541":"6fd5a3d3","652":"8e1a7d05"}[chunkId] + ".chunk.css";
};